
import React from 'react'
import "../styles/WikiPageContentContainer.sass"

const WikiPageContentContainer = ({ children }) => (
  <div className="wiki-page-content-container">{children}</div> 
)

export default WikiPageContentContainer;